import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBoxFeature: {
          module: () => import('./teaser-box.module').then((m) => m.TeaserBoxModule),
        },
      }
    }),
  ]
})
export class TeaserBoxFeatureModule {}
